import { createFileRoute } from '@tanstack/react-router';
import { KeyDetailPage } from '../../pages/dashboard/keys/KeyDetailPage';

export const Route = createFileRoute('/dashboard/keys/$keyId')({
  component: KeyDetailRoute,
});

function KeyDetailRoute() {
  const { keyId } = Route.useParams();
  return <KeyDetailPage key={keyId} keyId={keyId} />;
}
